import { Dayjs } from 'dayjs';

interface FormData {
	name: string;
	email: string;
	contactNo: string;
	eventType: string;
	noOfPeople: string;
	address: string;
	area: string;
	description: string;
	date: Dayjs | null; // Use Dayjs type
}

interface Errors {
	name?: string;
	email?: string;
	contactNo?: string;
	eventType?: string;
	noOfPeople?: string;
	address?: string;
	area?: string;
	description?: string;
	date?: string;
}

const validate = (values: FormData): Errors => {
	const errors: Errors = {};

	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	const contactPattern = /^[0-9]{10}$/;

	if (!values.name) {
		errors.name = 'Name is required';
	}

	if (!values.email) {
		errors.email = 'Email is required';
	} else if (!emailPattern.test(values.email)) {
		errors.email = 'Invalid email address';
	}

	if (!values.contactNo) {
		errors.contactNo = 'Contact number is required';
	} else if (!contactPattern.test(values.contactNo)) {
		errors.contactNo = 'Invalid contact number';
	}

	if (!values.eventType) {
		errors.eventType = 'Event type is required';
	}

	if (!values.noOfPeople) {
		errors.noOfPeople = 'Number of people is required';
	}

	if (!values.address) {
		errors.address = 'Address is required';
	}

	if (!values.area) {
		errors.area = 'Pincode is required';
	}

	if (!values.description) {
		errors.description = 'Description is required';
	}

	if (!values.date) {
		errors.date = 'Date is required';
	} else if (values.date.toDate() < new Date()) {
		errors.date = 'Date cannot be in the past';
	}

	return errors;
};

export default validate;
